import { FC } from 'react';
import ProTag, { TagProps } from './tag';
import ProCheckableTag, { CheckableTagProps } from './checkableTag';

export type ITagComponent = FC<TagProps & React.RefAttributes<HTMLElement>> & {
  CheckableTag: FC<CheckableTagProps>;
};

const TransTag = ProTag as ITagComponent;
TransTag.CheckableTag = ProCheckableTag;

export default TransTag;
